module.exports = __webpack_public_path__ + "static/img/1@2x.d71c662b.png";